import React, { useState, useRef, useEffect } from "react";
import "./Ourteam.css";
import { useNavigate } from "react-router-dom";
import oourteamlogo from "../../assets/ourteampage/ourteam_logo.png";
import hive_page_logo from "../../assets/allpages/hive_page_logo.png";
import union1 from "../../assets/ourteampage/union1.png";
import union2 from "../../assets/ourteampage/union2.png";
import GraphicDesSkill from "../../assets/ourteampage/member_boxes/skills/graphicdesign.png";
import UiDesignSkill from "../../assets/ourteampage/member_boxes/skills/uideisgn.png";
import WebDevSkill from "../../assets/ourteampage/member_boxes/skills/webdev.png";
import FiveMDevSkill from "../../assets/ourteampage/member_boxes/skills/fivemdev.png";
import lupus_photo from "../../assets/ourteampage/member_boxes/member_photos/lupus_photo.png";
import merilus_photo from "../../assets/ourteampage/member_boxes/member_photos/merilus_photo.png";
import korupt_photo from "../../assets/ourteampage/member_boxes/member_photos/korupt_photo.png";
import mario_photo from "../../assets/ourteampage/member_boxes/member_photos/mario_photo.png";

const Ourteam = () => {
  const navigate = useNavigate();
  const [currentMemberIndex] = useState(0);
  const memberRefs = useRef([]);
  const [isHovered, setIsHovered] = useState(false);

  const Members = [
    {
      name: "Pradais Samuel",
      position: "FullStack Developer",
      slug: "lupus",
      text: "Pradais Samuel, known as Lupus, is a skilled full stack web developer with over six years of experience. He has thrived in the FiveM community for five years, creating engaging and immersive experiences. Having worked with major companies, he brings a wealth of knowledge and expertise. Passionate about technology, he is dedicated to delivering innovative and impactful solutions that push boundaries and enhance user experiences. I love and I am a hard worker",
      skills: [{ img: FiveMDevSkill }, { img: WebDevSkill }],
      img: lupus_photo,
    },
    {
      name: "Mario M.",
      position: "Ui Designer",
      slug: "mariommm",
      text: "Mario, 18 years old, is passionate about UI/UX design. He enjoys creating modern, intuitive, and aesthetically pleasing interfaces, always focusing on user experience. He draws inspiration from current trends and combines creativity with functionality to bring ideas to life. His goal is to create designs that not only look good but also provide a smooth and engaging experience.",
      skills: [{ img: UiDesignSkill }, { img: GraphicDesSkill }],
      img: mario_photo,
    },
    {
      name: "Merila Cosmin",
      position: "Graphic Designer",
      slug: "merilus",
      text: "Merila Cosmin is a graphic and motion design enthusiast with over five years of experience in animations and visual elements, now exploring web design. His childhood passion for electromechanics and modeling led him to win awards in national and international competitions. After studying Automation and Applied Computer Science for a year, he found the teaching style unsuitable. His travels across Europe, including Italy and Croatia, have inspired his work.",
      skills: [{ img: GraphicDesSkill }, { img: UiDesignSkill }],
      img: merilus_photo,
    },
    {
      name: "Adrian G.",
      position: "Backend Developer",
      slug: "korrupt",
      text: "Hello, my name is Adrian! I am 24 years old and from Bucharest, Romania. I focus on development and own a private hosting company while working on various web development projects for clients. I am calm and dedicated, passionate about creating systems for games and turning clients' ideas into digital reality. Always seeking new challenges, I aim to expand my knowledge in technology. I value relaxation and fun, believing that balance is key to a fulfilling life.",
      skills: [{ img: WebDevSkill }],
      img: korupt_photo,
    },
  ];

  useEffect(() => {
    const checkPositions = () => {
      const boxes = document.querySelectorAll(".member_box");

      if (window.innerWidth >= 1000) {
        boxes.forEach((box) => {
          const left = box.getBoundingClientRect().left;
          const normalizedLeft = (left / window.innerWidth) * 100;

          if (normalizedLeft < 8) {
            box.classList.add("nonselected_hive");
          } else if (normalizedLeft > 70 && normalizedLeft < 80) {
            box.classList.remove("nonselected_hive");
          }
        });
      } else {
        boxes.forEach((box) => box.classList.remove("nonselected_hive"));
      }
    };

    const interval = setInterval(checkPositions, 100);
    window.addEventListener("resize", checkPositions);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", checkPositions);
    };
  }, []);

  const renderMemberBoxes = () => {
    const visibleMembers = [
      Members[(currentMemberIndex - 1 + Members.length) % Members.length],
      Members[currentMemberIndex],
      Members[(currentMemberIndex + 1) % Members.length],
      Members[(currentMemberIndex + 2) % Members.length],
    ];

    return visibleMembers.map((member, index) => (
      <div
        ref={(el) => (memberRefs.current[index] = el)}
        key={index}
        className="member_box"
        style={{ "--pos": index + 1 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="top_member_box">
          <div className="member_photo_container">
            <div className="first_layer"></div>
            <div className="second_layer"></div>
            <div className="third_layer">
              <img src={member.img} alt={member.name} />
            </div>
          </div>
          <div className="what_he_is">
            <h1>{member.position}</h1>
            <div className="vectorlinie"></div>
          </div>
        </div>
        <div className="bottom_member_box">
          <div className="top_skills">
            {member.skills.map((skill, skillIndex) => (
              <div key={skillIndex} className="skill_top">
                <div className="box_img_skill">
                  <img src={skill.img} alt={`Skill ${skillIndex}`} />
                </div>
              </div>
            ))}
          </div>
          <div className="center_text">
            <div className="member_name">{member.name}</div>
            <p>{member.text}</p>
            <button onClick={() => navigate(`/${member.slug}`)}>
              More Details
            </button>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="ourteamPage ourteam_page" id="ourteam">
      <div className="ourteam_container">
        <div className="ourteam_top">
          <div className="left_ourteam_top">
            <img src={oourteamlogo} alt="Our team logo" />
            <p>
              Our team is a dynamic and diverse group of talented professionals
              who each bring a unique set of skills and experiences. Below is a
              detailed description of each team member:
            </p>
          </div>
          <img
            className="hive_allpages"
            src={hive_page_logo}
            alt="Hive Page Logo"
          />
        </div>

        <div className="ourteam_center">
          <img className="unions" src={union1} alt="Union 1" />
          <div className={`ourteam_content ${isHovered ? "paused" : ""}`}>
            {renderMemberBoxes()}
          </div>
          <img className="unions" src={union2} alt="Union 2" />
        </div>
      </div>
    </div>
  );
};

export default Ourteam;
